export enum CapaciteStepEnum {
  REVENUS = 1,
  MISE_DE_FONDS,
  DETTES,
  TYPE_DE_DEPENSES,
  DEPENSES,
  PAIEMENT,
  HYPOTHEQUE,
  DEPENSES_TOTALES,
  QUESTION_TYPE_PROPRIETE
}
